import Axios from "axios";
import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../config";
import { authActions } from "../../../context/actions/authActions";
import useStore from "../../../context/useStore";

const RESEND_DELAY_SECONDS = 120;

const MustActivateAccount = () => {
  const [state, dispatch] = useStore();
  const aActions = authActions(state, dispatch);

  const [lastSentAt, setLastSentAt] = useState(
    state.auth.user.activationTokenSendedAt || null
  );
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [isSending, setIsSending] = useState(false);
  const [feedback, setFeedback] = useState(null); // {type: "success"|"error", text}

  // Décompte avant prochain renvoi possible, recalculé chaque seconde
  useEffect(() => {
    const compute = () => {
      if (!lastSentAt) return 0;
      const elapsed = DateTime.now().diff(DateTime.fromISO(lastSentAt), "seconds").seconds;
      return Math.max(0, Math.ceil(RESEND_DELAY_SECONDS - elapsed));
    };
    setSecondsLeft(compute());
    const interval = setInterval(() => setSecondsLeft(compute()), 1000);
    return () => clearInterval(interval);
  }, [lastSentAt]);

  const resendEmail = () => {
    setIsSending(true);
    setFeedback(null);
    Axios.post(API_URL + "customers/me/email_activation")
      .then((res) => {
        setLastSentAt(res.data.sentAt);
        setFeedback({
          type: "success",
          text: `Un nouvel email a été envoyé à ${res.data.email}.`,
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 429) {
          setLastSentAt(
            DateTime.now()
              .minus({ seconds: RESEND_DELAY_SECONDS - err.response.data.retryAfterSeconds })
              .toISO()
          );
          setFeedback({
            type: "error",
            text: "Un email vient déjà d'être envoyé, patientez avant de réessayer.",
          });
        } else if (err.response && err.response.status === 409) {
          window.location.reload();
        } else {
          setFeedback({
            type: "error",
            text: "L'envoi a échoué, veuillez réessayer.",
          });
        }
      })
      .then(() => setIsSending(false));
  };

  const formatCountdown = (seconds) =>
    `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        marginTop: -64,
      }}
      className="d-center "
    >
      <div
        className="d-center flex-column mx-auto bg-blue p-4 shadow-small  text-left "
        style={{
          maxWidth: 350,
          fontSize: 16,
          borderRadius: 20,
        }}
      >
        <img src="/images/logo-small.svg" alt="Perceval" style={{ height: 60 }} />
        <p className="d-block w-100 mt-4">
          <strong>
            Vous devez activer votre compte pour pouvoir accéder à votre Espace
            client.{" "}
          </strong>
        </p>
        {lastSentAt && (
          <p className="d-block w-100">
            Un email contenant votre lien d'activation vous a été envoyé le{" "}
            {DateTime.fromISO(lastSentAt).toFormat("dd/MM/yyyy")}.
          </p>
        )}
        <p className="d-block w-100">Pensez à vérifier dans vos spams.</p>

        {feedback && (
          <p
            className="d-block w-100 bg-white p-2 rounded"
            style={{
              color: feedback.type === "success" ? "#1e7a34" : "#a12013",
            }}
            role="status"
            aria-live="polite"
          >
            {feedback.text}
          </p>
        )}

        <button
          type="button"
          className="btn btn-primary text-white mb-2"
          style={{ minHeight: 44 }}
          disabled={isSending || secondsLeft > 0}
          onClick={resendEmail}
        >
          {secondsLeft > 0
            ? `Renvoyer dans ${formatCountdown(secondsLeft)}`
            : isSending
            ? "Envoi en cours..."
            : "Renvoyer l'email d'activation"}
        </button>
        <button
          type="button"
          className="btn btn-outline-primary mb-2"
          style={{ minHeight: 44 }}
          onClick={() => window.location.reload()}
        >
          J'ai activé mon compte
        </button>
        <button
          type="button"
          className="btn btn-link"
          style={{ minHeight: 44 }}
          onClick={() => aActions.logoutUser()}
        >
          Me déconnecter
        </button>
      </div>
    </div>
  );
};

export default MustActivateAccount;
